import React, { Fragment } from "react";
import PropTypes from "prop-types";
import MedicalQuestionnaireRecord from "./MedicalQuestionnaireRecord";

export const prefixArray = ["Employee", "Spouse", "FirstChild", "SecondChild", "ThirdChild"];

const createQuestionnaire = props => (
  <MedicalQuestionnaireRecord {...props} columns={prefixArray} />
);

const createRadioQuestionnaire = props =>
  createQuestionnaire({ ...props, type: "radio", options: ["Yes", "No"] });

const createInputQuestionnaire = props => createQuestionnaire({ ...props, type: "input" });

const furtherDeclareDesc = (
  <Fragment>
    <br />
    <b>{`If yes, please furnish details in the "Additional Remarks" section below`}</b>
  </Fragment>
);

const MedicalQuestionnaire = ({ data }) => {
  return (
    <fieldset>
      <h3 className="text--center">MEDICAL QUESTIONNAIRE</h3>
      <table className="health-declaration-medical-questionnaire">
        <thead className="header--black text--center">
          <tr>
            <td rowSpan={3} colSpan={2}>
              <b>All 11 questions must be answered</b>
            </td>
            <td colSpan={10} style={{ color: "red" }}>
              Complete ONLY IF to be insured
            </td>
          </tr>
          <tr>
            <td colSpan={2}>Employee</td>
            <td colSpan={2}>Spouse</td>
            <td colSpan={2}>
              1<sup>st</sup> Child
            </td>
            <td colSpan={2}>
              2<sup>nd</sup> Child
            </td>
            <td colSpan={2}>
              3<sup>rd</sup> Child
            </td>
          </tr>
          <tr>
            <td>Yes</td>
            <td>No</td>
            <td>Yes</td>
            <td>No</td>
            <td>Yes</td>
            <td>No</td>
            <td>Yes</td>
            <td>No</td>
            <td>Yes</td>
            <td>No</td>
          </tr>
        </thead>
        <tbody>
          {createRadioQuestionnaire({
            data,
            questionId: "Ques1",
            questionNumber: 1,
            questionDesc:
              "Do you engage in any sports(s) or occupation of a dangerous or hazardous nature such as motor racing, scuba/skin diving, parachuting, military (excluding NS) or private flying other than as a fare paying passenger, etc.?",
            furtherDeclareDesc,
          })}
          {createRadioQuestionnaire({
            data,
            questionId: "Ques2",
            questionNumber: 2,
            questionDesc:
              "Has any of your application / reinstatement for life, critical illness, accident, disability income, medical insurance ever been declined, postponed, or accepted with special terms (eg: extra premium loading or exclusion imposed)?",
            furtherDeclareDesc,
          })}
          {createRadioQuestionnaire({
            data,
            questionId: "Ques3a",
            questionNumber: 3,
            questionDesc:
              "a) Have you ever used addictive drugs, narcotics, glue sniffing or been treated for drug addiction?",
          })}
          {createRadioQuestionnaire({
            data,
            questionId: "Ques3b",
            questionDesc: "b) Have you ever had or been treated for alcoholism?",
            furtherDeclareDesc,
          })}
          {createRadioQuestionnaire({
            data,
            questionId: "Ques4",
            questionNumber: 4,
            questionDesc: "Do you drink wine, beer or other alcoholic beverages?",
            furtherDeclareDesc: "If yes, please furnish details:",
          })}
          {createInputQuestionnaire({
            data,
            questionId: "Ques4a",
            questionDesc: "a) Type of alcohol: (Beer / Wine / Others, please specifiy)",
          })}
          {createInputQuestionnaire({
            data,
            questionId: "Ques4b",
            questionDesc: "b) Frequency: (number of times per week)",
          })}
          {createInputQuestionnaire({
            data,
            questionId: "Ques4c",
            questionDesc: "c) Quantity: (mls / units per week)",
          })}
          {createRadioQuestionnaire({
            data,
            questionId: "Ques5",
            questionNumber: 5,
            questionDesc: "Have you ever smoked cigarettes in the last 12 months?",
            furtherDeclareDesc: (
              <div>
                <br />
                If yes, please furnish details:
              </div>
            ),
          })}
          {createInputQuestionnaire({
            data,
            questionId: "Ques5a",
            questionDesc: "a) Number of sticks per day:",
          })}
          {createRadioQuestionnaire({
            data,
            questionId: "Ques6a",
            questionNumber: 6,
            questionDesc:
              "a) Have you received any medical advice, counselling or treatment in connection with sexually transmitted disease, AIDS Related Complex or any other AIDS related condition?",
          })}
          {createRadioQuestionnaire({
            data,
            questionId: "Ques6b",
            questionDesc:
              "b) Have you ever had HIV testing done? If yes, please state the reason and its results.",
            furtherDeclareDesc,
          })}
          {createRadioQuestionnaire({
            data,
            questionId: "Ques7",
            questionNumber: 7,
            questionDesc:
              "In the past 3 months, have you ever had any of the following symptoms for more than one week continuously: Fatigue, weight loss, enlarged node(s) or unusual skin lesion(s)?",
            furtherDeclareDesc,
          })}
          {createRadioQuestionnaire({
            data,
            questionId: "Ques8",
            questionNumber: 8,
            questionDesc:
              "In the past 5 years, have you ever undergone or been advised to undergo any medical investigation(s) carried out on the recommendation of a doctor such as X-ray, Ultrasound, Heart scan, CT scan, Biopsy, Endoscopy, Gastroscopy, Colonoscopy, Surgical operation, etc.?",
            furtherDeclareDesc,
          })}
          <tr>
            <td>9</td>
            <td>Have you EVER had or been told you had or been treated for:</td>
            <td colSpan="2" />
            <td colSpan="2" />
            <td colSpan="2" />
            <td colSpan="2" />
            <td colSpan="2" />
          </tr>
          {createRadioQuestionnaire({
            data,
            questionId: "Ques9a",
            questionDesc:
              "a) Asthma, coughing with blood, pneumonia, tuberculosis, bronchitis, breathing discomfort or breathlessness and/or any other lung disease/disorder?",
          })}
          {createRadioQuestionnaire({
            data,
            questionId: "Ques9b",
            questionDesc:
              "b) Rheumatic fever, high blood pressure, heart murmur, heart attack, coronary artery disease, mitral valve prolapse, or other heart valve disorder, irregular or fast heart rate, chest discomfort or chest pain, and / or any disease or disorder of the heart or blood vessels?",
          })}
          {createRadioQuestionnaire({
            data,
            questionId: "Ques9c",
            questionDesc:
              "c) Renal/bladder stone(s), albumin/protein in urine, blood or sugar in urine, urine infection or any other disorder of the kidney(s), bladder, urinary or genital organs?",
          })}
          {createRadioQuestionnaire({
            data,
            questionId: "Ques9d",
            questionDesc:
              "d) Epilepsy, fits, stroke, paralysis, dementia, Parkinson's disease, multiple sclerosis, motor neurone disease, weakness of limbs, polio, fainting spells, prolonged headache, anxiety, depression, or any other nervous or mental disorder(s) or disease of the brain?",
          })}
          {createRadioQuestionnaire({
            data,
            questionId: "Ques9e",
            questionDesc: "e) Diabetes, thyroid disorder(s), or any other endocrine disorder(s)",
          })}
          {createRadioQuestionnaire({
            data,
            questionId: "Ques9f",
            questionDesc:
              "f) Gastritis, ulcer, blood in stools, fistula, hernia, irritable bowel syndrome, or any other disease/disorder of the stomach or bowel",
          })}
          {createRadioQuestionnaire({
            data,
            questionId: "Ques9g",
            questionDesc:
              "g) Hepatitis B carrier or any form of hepatitis, jaundice, liver disorder or gall bladder disorder",
          })}
          {createRadioQuestionnaire({
            data,
            questionId: "Ques9h",
            questionDesc:
              "h) Ear discharge, nose bleeding, double vision, impaired sight, hearing or speech, or any other disorder of the ear(s), eye(s), nose, or throat?",
          })}
          {createRadioQuestionnaire({
            data,
            questionId: "Ques9i",
            questionDesc:
              "i) Slipped disc, back pain, gout, any form of arthritis, joint pain or deformity, and/ or any disease/disorder of the muscles, spine, limbs or joints or severe injury?",
          })}
          {createRadioQuestionnaire({
            data,
            questionId: "Ques9j",
            questionDesc:
              "j) Anaemia, any other disorders of the blood, or advised to abstrain from donating or received blood transfusion?",
          })}
          {createRadioQuestionnaire({
            data,
            questionId: "Ques9k",
            questionDesc: "k) Cancer, tumour(s), cyst(s) or growth(s) of any kind?",
          })}
          {createRadioQuestionnaire({
            data,
            questionId: "Ques9l",
            questionDesc:
              "l) Congenital anomalies, physical disability or any other illness, disorder, operations, hospital admission, accident or injury not mentioned above?",
            furtherDeclareDesc,
          })}
          <tr style={{ backgroundColor: "#d40038", color: "white" }}>
            <td colSpan="12">
              <b>For Female Applicants only (including children age 12 year and above)</b>
            </td>
          </tr>
          {createRadioQuestionnaire({
            data,
            questionId: "Ques10a",
            questionNumber: 10,
            questionDesc:
              "a) Have you ever been to any doctor for a Pap Smear (cervical smear)? If yes, please state result:",
          })}
          {createInputQuestionnaire({
            data,
            questionId: "Ques10a-1",
            questionDesc: "(i) Result : (Normal / Abnormal)",
          })}
          {createRadioQuestionnaire({
            data,
            questionId: "Ques10b",
            questionDesc:
              "b) Have you ever had any abnormal pap smear test or been told by any doctor to have a repeat pap smear within 6 months?",
          })}
          {createRadioQuestionnaire({
            data,
            questionId: "Ques10c",
            questionDesc:
              "c) Have you ever been found to have or are you aware of any breast cyst(s) /lump(s) /nodule(s) or any other disease or disorder of the breast(s)?",
          })}
          {createRadioQuestionnaire({
            data,
            questionId: "Ques10d",
            questionDesc:
              "d) Have you ever suffered from irregular, painful or unusually heavy menstruation, fibroid(s), cyst(s) or any other disorder involving the female organ(s)?",
            furtherDeclareDesc,
          })}
          {createRadioQuestionnaire({
            data,
            questionId: "Ques11a",
            questionNumber: 11,
            questionDesc:
              "a) Were there any complication(s) noted during any of your pregnancy such as gestational diabetes, hypertension etc.? If yes, please provide details.",
            furtherDeclareDesc: "If yes, please furnish details:",
          })}
          {createInputQuestionnaire({
            data,
            questionId: "Ques11a-1",
            questionDesc: "(i) Details :",
          })}
          {createRadioQuestionnaire({
            data,
            questionId: "Ques11b",
            questionDesc: "b) Are you currently pregnant?",
          })}
          {createInputQuestionnaire({
            data,
            questionId: "Ques11b-1",
            questionDesc: "If yes, please state weeks of pregnancy :",
          })}
        </tbody>
      </table>
    </fieldset>
  );
};

MedicalQuestionnaire.propTypes = {
  data: PropTypes.object,
};

export default MedicalQuestionnaire;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Aia/AIAHD201906/MedicalQuestionnaire.jsx